import { io, Socket } from 'socket.io-client';
import { create } from 'zustand';
import { ROLE } from '@/shared/const/roles';

export interface UserStoreUser {
  id: number;
  email: string;
  name: string;
  coins: number;
  role: ROLE;
  avatar: string;
  support: number[];
}

export interface UserStore {
  user?: UserStoreUser | null;
  socket?: Socket | null;
  isInitialized: boolean;
  init: () => void;
  setUser: (user: UserStoreUser) => void;
  unsetUser: () => void;
}

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  isInitialized: false,
  init: () => {
    set({ isInitialized: true });
  },
  setUser: (user: UserStoreUser | null) => {
    set({ user, isInitialized: true, socket: user ? io() : null });
  },
  unsetUser: () => {
    set({ user: null, socket: null });
  },
}));
